import { CSSProperties } from 'react'

export const overlayStyles = {
  zIndex: 100,
  background: 'rgba(0, 0, 0, 0.85)'
}

export const contentStyles: CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  height: '90%',
  width: '90%',
  maxHeight: '412px',
  maxWidth: '400px',
  boxSizing: 'border-box',
  border: 'none',
  boxShadow: '0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08)',
  padding: '0'
}
